import i18next from 'i18next';
import { AxiosError } from 'axios';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@mui/material';

import Text from '@commons/Text';
import { CLIENTS_MODULE_PATHS } from '@src/commons/features/utils/modulePaths';
import { ENUM_FONTS, ENUM_COLORS } from '@commons/Text/textEnums';
import { getTheme } from '@commons/utils/theme';

import { login } from '@src/services/loginService';

import {
  Container,
  SideBar,
  WhiteCard,
  TitleContainer,
  ButtonContainer,
  Title,
  getButtonStyle
} from './styledComponents';

const Login = () => {
  const navigate = useNavigate();

  const theme = getTheme();

  const [loginFailedText, setLoginFailedText] = useState('');

  const handleLogin = useGoogleLogin({
    onSuccess: async (receivedToken) => {
      try {
        const jwtToken = await login(receivedToken);

        localStorage.setItem('accessToken', jwtToken.accessToken);

        navigate(CLIENTS_MODULE_PATHS.CLIENTS);
      } catch (err) {
        const error = err as AxiosError;
        const status = error.response?.status;

        setLoginFailedText(
          i18next.t(
            status === 401
              ? 'LOGIN.UNAUTHORIZED_AUTHENTICATION'
              : 'LOGIN.GOOGLE_AUTHENTICATION_ERROR'
          )
        );
      }
    },
    onError: () => setLoginFailedText(i18next.t('LOGIN.GOOGLE_AUTHENTICATION_ERROR'))
  });

  return (
    <Container>
      <SideBar>
        <img src="/images/inpulse-logo-catch-phrase.svg" alt="" />
      </SideBar>
      <WhiteCard>
        <TitleContainer>
          <Title data-text="Inpulse">Back-office Inpulse</Title>
          <Text color={ENUM_COLORS.IP_BLACK_4} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_24}>
            Inpulse we trust !
          </Text>
        </TitleContainer>
        <ButtonContainer>
          <Button
            variant="outlined"
            onClick={() => {
              handleLogin();
            }}
            sx={getButtonStyle(theme)}
          >
            <img src="/images/google-logo.svg" alt="" />
            <Text font={ENUM_FONTS.TEXT_SMALL_HEIGHT_24}>
              {i18next.t('LOGIN.GOOGLE_AUTHENTICATION')}
            </Text>
          </Button>
          {!!loginFailedText && (
            <Text color={ENUM_COLORS.ERROR} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_24}>
              {loginFailedText}
            </Text>
          )}
        </ButtonContainer>
      </WhiteCard>
    </Container>
  );
};

export default Login;
